<template>
  <div class="detalis">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      警报详情
    </div>
    <el-form
      class="warningDetail"
      ref="dataForm"
      :model="dataForm"
      label-width="100px"
    >
      <el-form-item label="流量计名称:" prop="flowMeterName">
        <el-input v-model="dataForm.flowMeterName" disabled />
      </el-form-item>
      <el-form-item label="创建时间:" prop="createTime">
        <el-input v-model="dataForm.createTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次流量更新时间：{{ dataForm.lastFlowTime }}</p>
      <el-form-item label="流量更新时间:" prop="flowTime">
        <el-input v-model="dataForm.flowTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次流量值：{{ dataForm.lastFlowValue }}</p>
      <el-form-item label="流量值:" prop="flowValue">
        <el-input v-model="dataForm.flowValue" disabled />
      </el-form-item>
      <p class="tipsValue">上次压力更新时间：{{ dataForm.lastPressTime }}</p>
      <el-form-item label="压力更新时间:" prop="pressTime">
        <el-input v-model="dataForm.pressTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次压力值：{{ dataForm.lastPressValue }}</p>
      <el-form-item label="压力值:" prop="pressValue">
        <el-input v-model="dataForm.pressValue" disabled />
      </el-form-item>
      <el-form-item label="电力更新时间:" prop="electricTime">
        <el-input v-model="dataForm.electricTime" disabled />
      </el-form-item>
      <el-form-item label="电力状态:" prop="status">
        <el-select v-model="dataForm.status" disabled>
          <el-option
            v-for="item in statusOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="警报描述:" prop="description">
        <el-input v-model="dataForm.description" type="textarea" rows="8" disabled />
      </el-form-item>
      <el-table
        :data="pressList"
        v-if="pressList && pressList.length > 0"
        border
        lazy
        style="width: 100%;margin: 0 0 40px;"
      >
        <el-table-column
          prop="time"
          header-align="center"
          align="center"
          fixed="left"
          label="压力时间"
        />
        <el-table-column
          prop="value"
          header-align="center"
          align="center"
          label="压力值"
        />
      </el-table>
      <el-table
        :data="flowList"
        v-if="flowList && flowList.length > 0"
        border
        lazy
        style="width: 100%;margin: 0 0 40px;"
      >
        <el-table-column
          prop="time"
          header-align="center"
          align="center"
          fixed="left"
          label="流量时间"
        />
        <el-table-column
          prop="value"
          header-align="center"
          align="center"
          label="流量值"
        />
      </el-table>
      <el-table
        :data="dataList"
        border
        v-if="dataForm.isConfirm == 1"
        lazy
        style="width: 100%;margin: 0 0 40px;"
      >
        <el-table-column
          prop="name"
          header-align="center"
          align="center"
          width="100"
          fixed="left"
          label="用户名"
        />
        <el-table-column
          prop="time"
          header-align="center"
          align="center"
          label="时间"
        />
        <el-table-column
          prop="remark"
          header-align="center"
          align="center"
          label="备注"
        />
      </el-table>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: '',
      dataForm: {
        createTime: null,  // 创建时间
        confirmRemark: null,  // 确认备注
        confirmUserNames: null, // 记录点击确认按钮的用户信息
        confirmUserId: null,  // 确认用户id
        confirmTime: null,  // 确认时间
        description: null,  // 警报描述
        electricTime: null, // 电力更新时间
        equipmentId: 0, // 流量计id
        flowLowerLimit: null, //  流量下限值
        flowMeterName: null,  //  调整流量计名称
        flowTime: null, //  流量更新时间
        flowUpperLimit: null, //  流量上限值
        flowValue: null,  //  流量值
        id: 0,  //  警报id
        isConfirm: 0, // 判断是否有点确认（0是未确认，1是确认了）
        isFlowAlarm: 0, // 是否流量报警
        isOutageAlarm: 0, // 是否断电报警
        isPressAlarm: 0,  // 是否压力报警
        name: null, // 流量计名称
        pressLowerLimit: null,  // 压力下限值
        pressTime: null,  // 压力更新时间
        pressUpperLimit: null,  // 压力上限值
        pressValue: null, // 压力值
        status: 1, //  电力状态 0备用电池，1通电
        type: 1, // 类型：1调度中心爬取，2丹灶数据，3纯手抄
        lastFlowTime: null, // 上次流量更新时间
        lastFlowValue: null,  // 上次流量值
        lastPressTime: null, // 上次压力更新时间
        lastPressValue: null  // 上次压力值
      },
      statusOptions: [
        {id: 0, name: "备用电池"},
        {id: 1, name: "通电"}
      ],
      orderDetails: {}, // 工单详情
      dataList: [], // 谁点击后的记录信息列表
      pressList: [], // 压力列表
      flowList: [], // 流量列表
      assetsType: '', // 资产类型
      reload: '', // 是否更新数据
      dialogVisible: false,
      loading: true
    }
  },
  // 解决keep-alive的冲突
  beforeRouteEnter (to, from, next) {
    if (from.path === '/record' || from.path === '/remindrecord') {
      next(vm => {
        // 通过 `vm` 访问组件实例
        vm.getDetailsById()
      })
    } else {
      next()
    }
  },
  methods: {
    // 返回首页
    backIndex() {
      this.$router.go(-1)
    },
    getDetailsById () {
      // 先拿id
      this.id = this.$route.query.id
      // 然后拿工单详情
      this.$http.httpGet(`/app/tbAlarmRecord/inf/`+ this.id).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.dataForm = res.tbAlarmRecord;
          this.pressList = res.tbAlarmRecord.pressList;
          this.flowList = res.tbAlarmRecord.flowList;
          this.flowList.map(row => row.time = row.time.substr(0, 16));
          this.pressList.map(row => row.time = row.time.substr(0, 16));
          if (res.tbAlarmRecord && res.tbAlarmRecord.isConfirm === 1) {
            this.dataList = [{
              name: res.tbAlarmRecord.confirmUserName,
              time: res.tbAlarmRecord.confirmTime,
              remark: res.tbAlarmRecord.confirmRemark
            }];
            console.log(this.dataList)
          }
        } else {
          // this.$message.error(res.msg)
          this.$alert('获取报警信息出错, 原因:' + res.msg, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              window.history.back(-1)
            }
          });
        }
      })
    }
  },
  created () {
    this.getDetailsById()
  }
}
</script>

<style lang="scss">
@use '@/assets/style/global.scss';
.detalis {
  background-color: #fff;
  padding: 60px 0 0;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #409eff;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .warningDetail {
    position: relative;
    padding: 0 15px;
    .el-form-item {
      margin: 0 0 15px;
      position: relative;
      .el-form-item__label {
        font-size: 12px;
        width: 100px;
        float: left;
      }
      .el-form-item__content {
        width: calc(100% - 100px);
        .el-input, .el-select {
          width: 100%;
        }
      }
    }
    .tipsValue {
      font-size: 13px;
      line-height: 1.4;
      margin: 0 0 8px;
      font-weight: 600;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px 20px;
  color: #606266;
  font-size: 16px;
  word-break: break-all;
}
.el-message-box {
  width: 35rem;
}
</style>
